import { useMemo, useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { ColorNeutral6, ColorBlue1, ColorBlue2, ColorBlue3, ColorBlue4, ColorBlue5, ColorBlue6, ColorBlue7, ColorBlue8, ColorBlue9, ColorBlue10, ColorGreen1, ColorGreen2, ColorGreen3, ColorGreen4, ColorGreen5, ColorGreen6, ColorGreen7, ColorGreen8, ColorGreen9, ColorGreen10, ColorNeutral1, ColorNeutral2, ColorNeutral3, ColorNeutral4, ColorNeutral5, ColorNeutral7, ColorNeutral8, ColorNeutral9, ColorNeutral10, ColorNeutral11, ColorNeutral12, ColorNeutral13, ColorNeutral14, ColorNeutral15, ColorNeutral16, ColorNeutral17, ColorNeutral18, ColorRed1, ColorRed2, ColorRed3, ColorRed4, ColorRed5, ColorRed6, ColorRed7, ColorRed8, ColorRed9, ColorRed10, ColorPurple1, ColorPurple2, ColorPurple3, ColorPurple4, ColorPurple5, ColorPurple6, ColorPurple7, ColorPurple8, ColorPurple9, ColorPurple10, ColorYellow1, ColorYellow2, ColorYellow3, ColorYellow4, ColorYellow5, ColorYellow6, ColorYellow7, ColorYellow8, ColorYellow9, ColorYellow10, ColorAccentA1, ColorAccentA2, ColorAccentA3, ColorAccentB1, ColorAccentB2, ColorAccentB3, ColorAccentC1, ColorAccentC2, ColorAccentC3, ColorAccentD1, ColorAccentD2, ColorAccentD3, ColorAccentE1, ColorAccentE2, ColorAccentE3, ColorAccentF1, ColorAccentF2, ColorAccentF3, ColorAccentG1, ColorAccentG2, ColorAccentG3, ColorAccentH1, ColorAccentH2, ColorAccentH3, ColorAccentI1, ColorAccentI2, ColorAccentI3, ColorAccentJ1, ColorAccentJ2, ColorAccentJ3, ColorHeaderGradientStart, ColorHeaderGradientEnd, ColorAdminBackground, ColorAdminBorder, ColorAdminText, ColorAdminVisitedLink, ColorChartA, ColorChartB, ColorChartC, ColorChartD, ColorChartE, ColorChartF, ColorChartG, ColorChartH, ColorChartI, ColorChartJ, ColorStatusPositive, ColorStatusWarning, ColorStatusNegative } from '@magnetic/design-tokens';
export { ColorNeutral18 as Black, ColorNeutral1 as White } from '@magnetic/design-tokens';
import CColor from 'color';

var __defProp$8 = Object.defineProperty;
var __name$8 = (target, value) => __defProp$8(target, "name", { value, configurable: true });
const sizeMap = {
  sm: "small",
  md: "middle",
  lg: "large"
};
const useAntSize = /* @__PURE__ */ __name$8((size) => useMemo(() => sizeMap[size], [size]), "useAntSize");

var __defProp$7 = Object.defineProperty;
var __name$7 = (target, value) => __defProp$7(target, "name", { value, configurable: true });
const breakpoints = ["sm", "md", "lg", "xl", "xxl"];
const BreakpointMatchers = {
  sm: { pixels: [0, 960], kind: "minMax" },
  md: { pixels: [960, 1280], kind: "minMax" },
  lg: { pixels: [1280, 1680], kind: "minMax" },
  xl: { pixels: [1680, 2080], kind: "minMax" },
  xxl: { pixels: [2081, Number.MAX_SAFE_INTEGER], kind: "min" }
};
const buildMediaQuery = /* @__PURE__ */ __name$7((breakpoint) => {
  switch (breakpoint.kind) {
    case "min":
      return { minWidth: breakpoint.pixels[0] };
    case "max":
      return { maxWidth: breakpoint.pixels[0] };
    case "minMax":
      return {
        minWidth: breakpoint.pixels[0],
        maxWidth: breakpoint.pixels[1]
      };
  }
}, "buildMediaQuery");
const useContainerBreakpoint = /* @__PURE__ */ __name$7((container, callback) => {
  const [targetWidth, setTargetWidth] = useState(0);
  useEffect(() => {
    const RO = new ResizeObserver((entries) => {
      var _a;
      const [entry] = entries;
      setTargetWidth(((_a = entry == null ? void 0 : entry.contentRect) == null ? void 0 : _a.width) || 0);
      callback == null ? void 0 : callback(true);
    });
    if ((container == null ? void 0 : container.current) || document.body) {
      RO.observe((container == null ? void 0 : container.current) || document.body);
    }
    return () => {
      RO.disconnect();
    };
  }, [container, callback]);
  let result = "xxl";
  for (const breakpoint of breakpoints) {
    if (targetWidth && targetWidth >= BreakpointMatchers[breakpoint].pixels[0]) {
      result = breakpoint;
    }
  }
  return (container == null ? void 0 : container.current) || document.body ? result : "xxl";
}, "useContainerBreakpoint");
const useBreakpoint = /* @__PURE__ */ __name$7((callback) => {
  const results = [
    useMediaQuery(buildMediaQuery(BreakpointMatchers.sm), void 0, callback),
    useMediaQuery(buildMediaQuery(BreakpointMatchers.md), void 0, callback),
    useMediaQuery(buildMediaQuery(BreakpointMatchers.lg), void 0, callback),
    useMediaQuery(buildMediaQuery(BreakpointMatchers.xl), void 0, callback),
    useMediaQuery(buildMediaQuery(BreakpointMatchers.xxl), void 0, callback)
  ];
  return breakpoints[results.indexOf(true)];
}, "useBreakpoint");

var __defProp$6 = Object.defineProperty;
var __name$6 = (target, value) => __defProp$6(target, "name", { value, configurable: true });
const usePickerFormat = /* @__PURE__ */ __name$6((format, picker) => useMemo(() => {
  let result = "";
  switch (picker) {
    case "quarter":
      result = "[Q]Q YYYY";
      break;
    case "month":
      result = "MMM YYYY";
      break;
    case "year":
      result = "YYYY";
      break;
    default:
      result = format;
  }
  return result;
}, [format, picker]), "usePickerFormat");

var __defProp$5 = Object.defineProperty;
var __name$5 = (target, value) => __defProp$5(target, "name", { value, configurable: true });
const alpha = [0, 0.05, 0.08, 0.12, 0.333333333, 0.5, 0.666666666, 0.825, 0.95];
const opacify = /* @__PURE__ */ __name$5((color = ColorNeutral6, alphaLevel = 1) => CColor(color).alpha(alpha[alphaLevel]).toString(), "opacify");
const darken = /* @__PURE__ */ __name$5((color, percent) => CColor(color).darken(percent).hex().toString(), "darken");

const colors = {
  blue1: ColorBlue1,
  blue2: ColorBlue2,
  blue3: ColorBlue3,
  blue4: ColorBlue4,
  blue5: ColorBlue5,
  blue6: ColorBlue6,
  blue7: ColorBlue7,
  blue8: ColorBlue8,
  blue9: ColorBlue9,
  blue10: ColorBlue10,
  green1: ColorGreen1,
  green2: ColorGreen2,
  green3: ColorGreen3,
  green4: ColorGreen4,
  green5: ColorGreen5,
  green6: ColorGreen6,
  green7: ColorGreen7,
  green8: ColorGreen8,
  green9: ColorGreen9,
  green10: ColorGreen10,
  neutral1: ColorNeutral1,
  neutral2: ColorNeutral2,
  neutral3: ColorNeutral3,
  neutral4: ColorNeutral4,
  neutral5: ColorNeutral5,
  neutral6: ColorNeutral6,
  neutral7: ColorNeutral7,
  neutral8: ColorNeutral8,
  neutral9: ColorNeutral9,
  neutral10: ColorNeutral10,
  neutral11: ColorNeutral11,
  neutral12: ColorNeutral12,
  neutral13: ColorNeutral13,
  neutral14: ColorNeutral14,
  neutral15: ColorNeutral15,
  neutral16: ColorNeutral16,
  neutral17: ColorNeutral17,
  neutral18: ColorNeutral18,
  red1: ColorRed1,
  red2: ColorRed2,
  red3: ColorRed3,
  red4: ColorRed4,
  red5: ColorRed5,
  red6: ColorRed6,
  red7: ColorRed7,
  red8: ColorRed8,
  red9: ColorRed9,
  red10: ColorRed10,
  purple1: ColorPurple1,
  purple2: ColorPurple2,
  purple3: ColorPurple3,
  purple4: ColorPurple4,
  purple5: ColorPurple5,
  purple6: ColorPurple6,
  purple7: ColorPurple7,
  purple8: ColorPurple8,
  purple9: ColorPurple9,
  purple10: ColorPurple10,
  yellow1: ColorYellow1,
  yellow2: ColorYellow2,
  yellow3: ColorYellow3,
  yellow4: ColorYellow4,
  yellow5: ColorYellow5,
  yellow6: ColorYellow6,
  yellow7: ColorYellow7,
  yellow8: ColorYellow8,
  yellow9: ColorYellow9,
  yellow10: ColorYellow10,
  accentA1: ColorAccentA1,
  accentA2: ColorAccentA2,
  accentA3: ColorAccentA3,
  accentB1: ColorAccentB1,
  accentB2: ColorAccentB2,
  accentB3: ColorAccentB3,
  accentC1: ColorAccentC1,
  accentC2: ColorAccentC2,
  accentC3: ColorAccentC3,
  accentD1: ColorAccentD1,
  accentD2: ColorAccentD2,
  accentD3: ColorAccentD3,
  accentE1: ColorAccentE1,
  accentE2: ColorAccentE2,
  accentE3: ColorAccentE3,
  accentF1: ColorAccentF1,
  accentF2: ColorAccentF2,
  accentF3: ColorAccentF3,
  accentG1: ColorAccentG1,
  accentG2: ColorAccentG2,
  accentG3: ColorAccentG3,
  accentH1: ColorAccentH1,
  accentH2: ColorAccentH2,
  accentH3: ColorAccentH3,
  accentI1: ColorAccentI1,
  accentI2: ColorAccentI2,
  accentI3: ColorAccentI3,
  accentJ1: ColorAccentJ1,
  accentJ2: ColorAccentJ2,
  accentJ3: ColorAccentJ3
};
const tagColors = {
  accentA1: colors.accentA1,
  accentB1: colors.accentB1,
  accentC1: colors.accentC1,
  accentD1: colors.accentD1,
  accentE1: colors.accentE1,
  accentF1: colors.accentF1,
  accentG1: colors.accentG1,
  accentH1: colors.accentH1,
  accentI1: colors.accentI1,
  accentJ1: colors.accentJ1
};
const headerGradient = {
  startColor: ColorHeaderGradientStart,
  endColor: ColorHeaderGradientEnd
};
const adminColors = {
  fill: ColorAdminBackground,
  border: ColorAdminBorder,
  text: ColorAdminText,
  visitedLink: ColorAdminVisitedLink
};
const chartColors = [
  ColorChartA,
  ColorChartB,
  ColorChartC,
  ColorChartD,
  ColorChartE,
  ColorChartF,
  ColorChartG,
  ColorChartH,
  ColorChartI,
  ColorChartJ
];
const statusColors = {
  positive: ColorStatusPositive,
  warning: ColorStatusWarning,
  negative: ColorStatusNegative
};

const gridColumns = 12;
const spacingSizes = {
  none: 0,
  xxs: 4,
  xs: 8,
  sm: 12,
  md: 16,
  lg: 24,
  xl: 36,
  xxl: 48
};

const fallbackFonts = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
const codeFallbackFonts = "Roboto Mono, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, Courier, monospace";
const fontFamilies = {
  body: `Inter, ${fallbackFonts}`,
  code: `${codeFallbackFonts}`,
  heading: `'Sharp Sans', ${fallbackFonts}`
};
const fontWeights = {
  regular: 400,
  semiBold: 600,
  bold: 700
};
const fontSizes = {
  xxxs: 12,
  xxs: 14,
  xs: 16,
  sm: 18,
  md: 24,
  lg: 32,
  xl: 40,
  xxl: 48,
  xxxl: 60
};
const lineHeights = {
  xxxs: 18,
  xxs: 20,
  xs: 22,
  sm: 24,
  md: 34,
  lg: 44,
  xl: 52,
  xxl: 60,
  xxxl: 72
};

var __defProp$4 = Object.defineProperty;
var __name$4 = (target, value) => __defProp$4(target, "name", { value, configurable: true });
const convertNumberToPixelValue = /* @__PURE__ */ __name$4((value) => {
  const suffix = value === 0 ? "" : "px";
  return value + suffix;
}, "convertNumberToPixelValue");

const spaces = {
  "mds-space-none": convertNumberToPixelValue(spacingSizes.none),
  "mds-space-xxs": convertNumberToPixelValue(spacingSizes.xxs),
  "mds-space-xs": convertNumberToPixelValue(spacingSizes.xs),
  "mds-space-sm": convertNumberToPixelValue(spacingSizes.sm),
  "mds-space-md": convertNumberToPixelValue(spacingSizes.md),
  "mds-space-lg": convertNumberToPixelValue(spacingSizes.lg),
  "mds-space-xl": convertNumberToPixelValue(spacingSizes.xl),
  "mds-space-xxl": convertNumberToPixelValue(spacingSizes.xxl)
};

const margins = {
  "margin-none": spaces["mds-space-none"],
  "margin-xxs": spaces["mds-space-xxs"],
  "margin-xs": spaces["mds-space-xs"],
  "margin-sm": spaces["mds-space-sm"],
  "margin-md": spaces["mds-space-md"],
  "margin-lg": spaces["mds-space-lg"],
  "margin-xl": spaces["mds-space-xl"],
  "margin-xxl": spaces["mds-space-xxl"]
};

var VAlignMap = /* @__PURE__ */ ((VAlignMap2) => {
  VAlignMap2["baseline"] = "baseline";
  VAlignMap2["bottom"] = "end";
  VAlignMap2["middle"] = "center";
  VAlignMap2["top"] = "start";
  return VAlignMap2;
})(VAlignMap || {});

var Shadows = /* @__PURE__ */ ((Shadows2) => {
  Shadows2["lifted"] = "lifted";
  Shadows2["liftedReverse"] = "liftedReverse";
  Shadows2["none"] = "none";
  Shadows2["raised"] = "raised";
  Shadows2["raisedReverse"] = "raisedReverse";
  Shadows2["subtle"] = "subtle";
  Shadows2["subtleReverse"] = "subtleReverse";
  return Shadows2;
})(Shadows || {});

var modalSizesMap = /* @__PURE__ */ ((modalSizesMap2) => {
  modalSizesMap2[modalSizesMap2["xl"] = 912] = "xl";
  modalSizesMap2[modalSizesMap2["lg"] = 768] = "lg";
  modalSizesMap2[modalSizesMap2["md"] = 576] = "md";
  modalSizesMap2[modalSizesMap2["sm"] = 384] = "sm";
  return modalSizesMap2;
})(modalSizesMap || {});

var BorderStyles = /* @__PURE__ */ ((BorderStyles2) => {
  BorderStyles2["bold"] = "bold";
  BorderStyles2["light"] = "light";
  BorderStyles2["medium"] = "medium";
  return BorderStyles2;
})(BorderStyles || {});
var ScrollBarStyles = /* @__PURE__ */ ((ScrollBarStyles2) => {
  ScrollBarStyles2["medium"] = "medium";
  return ScrollBarStyles2;
})(ScrollBarStyles || {});

var FontFamilies = /* @__PURE__ */ ((FontFamilies2) => {
  FontFamilies2["body"] = "body";
  FontFamilies2["code"] = "code";
  FontFamilies2["heading"] = "heading";
  return FontFamilies2;
})(FontFamilies || {});

var __defProp$3 = Object.defineProperty;
var __name$3 = (target, value) => __defProp$3(target, "name", { value, configurable: true });
function consoleWarn(warnings, ...rest) {
  const warningsArray = Array.isArray(warnings) ? warnings : [warnings];
  for (const warning of warningsArray) {
    const { message, prop, propValues } = warning;
    if (prop && !propValues || prop && propValues && propValues.includes(prop)) {
      console.warn(`Magnetic: ${message}`, rest);
    } else {
      return void 0;
    }
  }
}
__name$3(consoleWarn, "consoleWarn");

var __defProp$2 = Object.defineProperty;
var __name$2 = (target, value) => __defProp$2(target, "name", { value, configurable: true });
const groupBy = /* @__PURE__ */ __name$2((array, criterion) => {
  var _a;
  const accumulator = {};
  for (const current of array) {
    const key = current[criterion];
    if (typeof key === "string") {
      if (key in accumulator) {
        (_a = accumulator[key]) == null ? void 0 : _a.push(current);
      } else {
        accumulator[key] = [current];
      }
    }
  }
  return accumulator;
}, "groupBy");

var __defProp$1 = Object.defineProperty;
var __name$1 = (target, value) => __defProp$1(target, "name", { value, configurable: true });
const capitalize = /* @__PURE__ */ __name$1((text) => text.charAt(0).toUpperCase() + text.slice(1), "capitalize");

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const truncate = /* @__PURE__ */ __name((text) => text.length > 32 ? `${text.slice(0, 29)}...` : text, "truncate");

export { BorderStyles, BreakpointMatchers, FontFamilies, ScrollBarStyles, Shadows, VAlignMap, adminColors, alpha, breakpoints, capitalize, chartColors, colors, consoleWarn, darken, fontFamilies, fontSizes, fontWeights, gridColumns, groupBy, headerGradient, lineHeights, margins, modalSizesMap, opacify, spacingSizes, statusColors, tagColors, truncate, useAntSize, useBreakpoint, useContainerBreakpoint, usePickerFormat };
//# sourceMappingURL=index.js.map
